import Vue from 'vue';
import Vuex from 'vuex';
import StoreModules from '@/helpers/store/modules.js';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: StoreModules
});
